module.exports = __webpack_public_path__ + "img/4_cover1.eeeee083.png";